export enum BRANDS {
    BILD = 'bild',
    WELT = 'welt'
}
